import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

// components
import { FormattedMessage } from 'react-intl';
import GearIcon from 'dibs-vg/dist/react/gear';

// helpers
import { showUserSurvey, shouldLaunchUserSurvey } from '../helpers/userSurvey';

// styles
import styles from './styles/FeedSettings.scss';

function FeedSettingsComponent({ viewer, onComplete }) {
    const hasTakenSurvey = get(viewer, 'userSurvey.hasTakenSurvey') || false;

    useEffect(() => {
        if (shouldLaunchUserSurvey()) {
            showUserSurvey().then(onComplete);
        }
    }, [onComplete]);

    return (
        <div className={styles.preference} onClick={() => showUserSurvey().then(onComplete)}>
            <GearIcon className={styles.icon} />
            {hasTakenSurvey ? (
                <FormattedMessage
                    id="discover.FeedSettings.title"
                    defaultMessage="My Preferences"
                />
            ) : (
                <FormattedMessage
                    id="discover.FeedSettings.surveyPrompt"
                    defaultMessage="Take Survey"
                />
            )}
        </div>
    );
}

FeedSettingsComponent.propTypes = {
    viewer: PropTypes.object,
    onComplete: PropTypes.func,
};

export const FeedSettings = createFragmentContainer(FeedSettingsComponent, {
    viewer: graphql`
        fragment FeedSettings_viewer on Viewer {
            userSurvey(userId: $userId) @include(if: $hasUserId) {
                hasTakenSurvey
            }
        }
    `,
});
